import React from "react";

import { Tooltip } from "@mui/material";
import ShipeeziNewGrid, { Column } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import BadgeStorageStatus from "../../../../../components/Generic/BadgeStorageStatus";
import SubHeader from "../../../../../components/Generic/SubHeader";
import { PRIVATE_ROUTES } from "../../../../../constants";
import { useAppState } from "../../../../../context/StateContext";
import { formatCurrency } from "../../../../../util/prices";
import {
  ChangeStatusIcon,
  DeleteIcon,
  SendEMailIcon,
  SettlementIcon,
  StorageAccountPrice,
  StorageAccountsGrid,
  ViewIcon,
} from "./styles";

export const StorageAccounts = () => {
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();
  const history = useHistory();

  const storageAccountsData: any[] = [
    {
      reference: "210 - Ayrton Senna",
      email: "ayrton.senna@zaplago.com",
      period: "Monthly",
      nextBilling: "04/05/2022",
      total: 244.2,
      status: "Active",
    },
    {
      reference: "210 - Ayrton Senna",
      email: "ayrton.senna@zaplago.com",
      period: "Weekly",
      nextBilling: "04/05/2022",
      total: 0,
      status: "Draft",
    },
    {
      reference: "210 - Ayrton Senna",
      email: "ayrton.senna@zaplago.com",
      period: "Yearly",
      nextBilling: "04/05/2022",
      total: 0,
      status: "Draft",
    },
  ];

  const columns: Column[] = [
    { name: "reference", title: translate("reference") },
    { name: "email", title: translate("email") },
    { name: "period", title: translate("period") },
    { name: "nextBilling", title: translate("nextBilling") },
    {
      name: "total",
      title: translate("total"),
      formatComponent: (price: number) => (
        <StorageAccountPrice>
          {`${currentUser?.company?.currency?.symbol ?? "$"} ${formatCurrency(
            price,
            currentUser?.company?.currency,
            false
          )}`}
        </StorageAccountPrice>
      ),
    },
    {
      name: "status",
      title: translate("status"),
      formatComponent: (status: string) => <BadgeStorageStatus value={status} />,
    },
  ];

  const viewStorageAccount = (index: number) => {
    const storageAccountToView = storageAccountsData.find(
      (storageAccount) => Number(storageAccount.id) === Number(index)
    );

    return (
      <Tooltip title={translate("view")} placement="top">
        <div>
          <ViewIcon size={18} color="#475467" onClick={() => {}} />
        </div>
      </Tooltip>
    );
  };

  const changeStatusStorageAccount = (index: number) => {
    const storageAccountToChangeStatus = storageAccountsData.find(
      (storageAccount) => Number(storageAccount.id) === Number(index)
    );

    return (
      <Tooltip title={translate("changeStatus")} placement="top">
        <div>
          <ChangeStatusIcon size={18} color="#475467" onClick={() => {}} />
        </div>
      </Tooltip>
    );
  };

  const sendEmailStorageAccount = (index: number) => {
    const storageAccountToSendEmail = storageAccountsData.find(
      (storageAccount) => Number(storageAccount.id) === Number(index)
    );

    return (
      <Tooltip title={translate("sendEmail")} placement="top">
        <div>
          <SendEMailIcon size={18} color="#475467" onClick={() => {}} />
        </div>
      </Tooltip>
    );
  };

  const settlementStorageAccount = (index: number) => {
    const storageAccountToSettlement = storageAccountsData.find(
      (storageAccount) => Number(storageAccount.id) === Number(index)
    );

    return (
      <Tooltip title={translate("settlement")} placement="top">
        <div>
          <SettlementIcon
            size={18}
            color="#32D583"
            onClick={() => {
              console.log(storageAccountToSettlement);
            }}
          />
        </div>
      </Tooltip>
    );
  };

  const deleteStorageAccount = (index: number) => {
    const storageAccountToDelete = storageAccountsData.find(
      (storageAccount) => Number(storageAccount.id) === Number(index)
    );

    return (
      <Tooltip title={translate("delete")} placement="top">
        <div>
          <DeleteIcon
            size={18}
            color="#F97066"
            onClick={() => {
              console.log(storageAccountToDelete);
            }}
          />
        </div>
      </Tooltip>
    );
  };

  return (
    <div data-cy="storageAccountsPage">
      <SubHeader title={translate("storageAccounts")} showWarehouseSelect />
      <StorageAccountsGrid data-cy="storageAccountsGrid">
        <ShipeeziNewGrid
          data={storageAccountsData}
          columns={columns}
          // totalItems={total}
          // loadingData={isFetching || isUpdating || isCreating}
          emptyData={translate("noInformationToBeShown")}
          // pageSize={pageSize}
          pageSizeList={[15, 40, 60, 100]}
          // onChangePageSize={setPageSize}
          // currentPage={page}
          // onNextPage={handleCurrentPage}
          // onPreviousPage={handleCurrentPage}
          // onGoToPage={handleCurrentPage}
          // onSorting={handleSorting}
          generalActions={{
            orderBy: {
              right: ["handleNewRecord"],
              left: ["handleSearch", "handleFilterBy"],
            },
            handleSearch: {
              onSearch: () => {},
            },
            handleFilterBy: {
              categories: [
                {
                  name: translate("status"),
                  column: "isActive",
                  options: [
                    { value: "1", label: translate("active") },
                    { value: "0", label: translate("inactive") },
                  ],
                },
              ],
              onChange: () => {},
            },
            handleNewRecord: {
              text: translate("createNew"),
              action: () => history.push(PRIVATE_ROUTES.STORAGE_ACCOUNTS_MNT),
              tooltip: translate("createNew"),
            },
          }}
          rowActions={{
            orderBy: [
              "handleView",
              "handleEdit",
              "handleSettlementStorageAccount",
              "handleChangeStatus",
              "handleSendEmailStorageAccount",
              "handleDeleteStorageAccount",
            ],
            handleEdit: () => {},
          }}
          rowActionsExtra={[
            { title: translate("view"), key: "handleView", buttonAndAction: viewStorageAccount },
            {
              title: translate("changeStatus"),
              key: "handleChangeStatus",
              buttonAndAction: changeStatusStorageAccount,
            },
            {
              title: translate("delete"),
              key: "handleDeleteStorageAccount",
              buttonAndAction: deleteStorageAccount,
            },
            {
              title: translate("send"),
              key: "handleSendEmailStorageAccount",
              buttonAndAction: sendEmailStorageAccount,
            },
            {
              title: translate("settlement"),
              key: "handleSettlementStorageAccount",
              buttonAndAction: settlementStorageAccount,
            },
          ]}
          positionActionsColumn="right"
        />
      </StorageAccountsGrid>
    </div>
  );
};
